<template>
  <div>
    <h1 class="text-pill text-pill--name">{{ playerName }}</h1>
    <div class="card">
      <div class="stat-item">
        <p class="text-pill">Questions</p>
        <p class="stats-text">{{ formattedResult }}</p>
      </div>
      <!-- <div class="stat-item">
        <p class="text-pill">Do-Over</p>
        <p class="stats-text">
          <span>{{ formattedDoOvers }}</span>
          <img
            src="@/assets/images/used-do-overs.svg"
            alt="used do-overs icon"
            class="icon"
          />
        </p>
      </div> -->
      <div class="stat-item">
        <p class="text-pill">Time</p>
        <p class="stats-text">{{ formattedTimeToComplete }}</p>
      </div>
      <div class="stat-item">
        <p class="text-pill">Coins</p>
        <p class="stats-text">
          <span>{{ formattedReward }}</span>
          <img
            src="@/assets/images/flourish-coin.svg"
            alt="flourish coin"
            width="20"
            height="20"
            class="icon"
          />
        </p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    playerName: {
      type: String,
      required: true,
    },
    correctAnswers: {
      type: Number,
      required: true,
    },
    // doOversUsed: {
    //   type: Number,
    //   required: true,
    // },
    reward: {
      type: Number,
      required: true,
    },
    timeToFinishInMilliseconds: {
      type: Number,
      required: true,
    },
    questionsAmount: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {};
  },
  computed: {
    formattedReward() {
      return `+${this.reward} `;
    },
    formattedTimeToComplete() {
      const totalTimeInSeconds = this.timeToFinishInMilliseconds / 1000;

      const minutes = Math.floor(totalTimeInSeconds / 60);
      const seconds = totalTimeInSeconds - minutes;
      const milliseconds = (totalTimeInSeconds - seconds) * 1000;

      return `${minutes}'${seconds}''${milliseconds}'''`;
    },
    // formattedDoOvers() {
    //   return `Used ${this.doOversUsed} `;
    // },
    formattedResult() {
      return `${this.correctAnswers} out of ${this.questionsAmount}`;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../scss/variables.scss";
@import "../scss/common.scss";

.card {
  display: flex;
  flex-direction: row;
  align-items: baseline;
  justify-content: space-evenly;
  padding: 2.5rem 0.5rem 1rem 0.5rem;

  background: $quaternary-darker;
  border: 0.25px solid #a3a3a3;
  box-sizing: border-box;
  box-shadow: 0px 37.4993px 97.0944px rgba(0, 0, 0, 0.0413989);
  border-radius: 10px;
}

.stat-item {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.text-pill {
  background: $primary-alternative;
  border-radius: 28px;
  padding: 0.3rem 0.8rem;
  margin-bottom: 0.5rem;

  font-family: $secondary-font;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 19px;
  text-align: center;
  color: $quaternary-darker;
}

.text-pill--name {
  font-size: 16px;
  position: relative;
  margin: 0 auto -1rem auto;
  width: 50%;
}

.stats-text {
  font-family: $secondary-font;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 15px;
  display: flex;
  align-items: center;
  color: $primary;
}

.icon {
  margin-left: 0.2rem;
}
</style>
